import * as ActionTypes from '../constants/actionTypes'
import { sellerPointCreate, sellerPointRead, sellerPointUpdate, sellerPointDelete } from '../api/seller'

export const editForm = formFieldsChange => ({
  type: ActionTypes.SELLERPOINTFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.SELLERPOINTFORM_ENTER_RESET,
})

export const fetchItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERPOINTFORM_FETCHITEM_LOAD })

  sellerPointRead(values).then((res) => {
    const item = res.result

    dispatch({
      type: ActionTypes.SELLERPOINTFORM_FETCHITEM_SUCCEED,
      item,
    })
    dispatch({
      type: ActionTypes.SELLERPOINTFORM_EDITFORM_CHANGE,
      field: {
        id: { name: 'idnum', value: item.idnum },
        s_name: { name: 's_name', value: item.s_name },
        s_number: { name: 's_number', value: item.s_number },
        s_address: { name: 's_address', value: item.s_address },
        n_time_offset: { name: 'n_time_offset', value: item.n_time_offset },
        s_identity: { name: 's_identity', value: item.s_identity },
      },
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERPOINTFORM_FETCHITEM_FAIL,
      fetchItemError: 'Ошибка получения данных по заведению торговой сети.',
    })
  })
}

export const createItem = values => (dispatch) => {
  // console.log(values)
  dispatch({ type: ActionTypes.SELLERPOINTFORM_CREATEITEM_LOAD })
  sellerPointCreate(values).then(() => {
    // dispatch({ type: ActionTypes.SELLERPOINTLIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.SELLERPOINTFORM_CREATEITEM_SUCCEED })
    // dispatch({ type: ActionTypes.SELLERPOINTFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERPOINTFORM_CREATEITEM_FAIL,
      createItemError: 'Ошибка создания заведения торговой сети.',
    })
  })
}

export const editItem = params => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERPOINTFORM_EDITITEM_LOAD })

  sellerPointUpdate(params).then(() => {
    dispatch({ type: ActionTypes.SELLERPOINTFORM_EDITITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERPOINTFORM_EDITITEM_FAIL,
      editItemError: 'Ошибка изменения данных.',
    })
  })
}

export const deleteItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERPOINTFORM_DELETEITEM_LOAD })

  sellerPointDelete(values).then(() => {
    dispatch({ type: ActionTypes.SELLERPOINTFORM_DELETEITEM_SUCCEED })
    // dispatch({ type: ActionTypes.SELLERPOINTFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERPOINTFORM_DELETEITEM_FAIL,
      deleteItemError: 'Ошибка удаления заведения торговой сети.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/sellerPointForm.js